import React,{useEffect, useState, useMemo } from "react";
import FilterBar from "../Filter/index.jsx";
import { useSelector } from "react-redux";

import Select from "react-select";
import KpisFilter from "../Filter/kpisFilter";
import { APIExport } from "../../apiwrapper/exportFida.ts";

const ExportData = () => {
  const translation = useSelector(state => state.root.translation);
  let { filter, listKpis2 } = useSelector((state) => state.filter);
  console.log('listKpis2',listKpis2);
  let { stores } = useSelector((state) => state.stores);
  const {
    selectedStart,
    selectedEnd,
    compareStart,
    compareEnd,
    selectedLocationStore,
    weekDaySelected,
    kpisSelected
  } = filter;

  const reportTypeOptions = [
    { label: translation?.hourly_total, value: 'hourly' },
    { label: translation?.daily, value: 'daily' },
    { label: translation?.all_stores_daily, value: 'AllStoresDaily' },
    // { label: t('demographics'), value: 'demographics' },
    { label: translation?.hourly_report_by_store, value: 'hourofdaykpi' }
  ];

  const [sortOrderOption] = useState([
    { label: translation?.ascending, value: "ASC" },
    { label: translation?.descending, value: "DESC" }
  ]);
  const [selectedOrder, setSelectedOrder] = useState(sortOrderOption[0]); // Default to "Ascending"
  const handleSortOrderChange = (selectedOption) => {
    setSelectedOrder(selectedOption);
  };
  
  // const kpiOption = useMemo(() => {
  //   return listKpis2?.map(item => ({ label: t(item), value: item })) || [];
  // }, [listKpis2, t]);
 
  // const [detailedSortOptions]= useState([
  //   { label: t('storenumber'), value: 'StoreNumber' },
  //   { label: t('store_name'), value: 'store' },
  //   ...kpiOption
  // ]);
  const kpiOption = useMemo(() => {
    return listKpis2?.map(item => ({ label: translation[item], value: item })) || [];
  }, [listKpis2, translation]);
  
  const [detailedSortOptions, setDetailedSortOptions] = useState([
    { label: translation?.storenumber, value: 'StoreNumber' },
    { label: translation?.store_name, value: 'store' }
  ]);
  
  // Use useEffect to update detailedSortOptions when kpiOption is computed
  // useEffect(() => {
  //   setDetailedSortOptions(prevOptions => [
  //     ...prevOptions, 
  //     ...kpiOption
  //   ]);
  // }, [kpiOption]);
  
  
  useEffect(() => {
    setDetailedSortOptions((prevOptions) => {
      const existingValues = new Set(prevOptions.map(option => option.value));
      const newOptions = kpiOption.filter(option => !existingValues.has(option.value));
      return [...prevOptions, ...newOptions];
    });
  }, [kpiOption]);
  
  const [selectedDetailedOrder, setSelectedDetailedOrder] = useState(detailedSortOptions[0]); // Default to "Ascending"
  const handledetailedSortChange = (selectedOption) => {
    setSelectedDetailedOrder(selectedOption);
  };

  const [reportType, setReportType] = useState(reportTypeOptions[0]); // Default to "Ascending"
  const handlereportType = (selectedOption) => {
    setReportType(selectedOption);
  };



  const [selectedKpiSingle, setSelectedKpiSingle] = useState(kpiOption[0]); // Default to "Ascending"
  const handleSelectedKpiSingleChange = (selectedOption) => {
    setSelectedKpiSingle(selectedOption);
  };



  const handleExport = async() => {
    console.log('Export button');
      try {
        console.log('selectedLocationStore',selectedLocationStore);
        if (!selectedLocationStore.length || selectedLocationStore.length == '' || selectedLocationStore.length == 0) {
          // this.$q.notify({
          //   type: 'negative',
          //   message: this.$t('kpi_alert'),
          //   position: 'top-right',
          //   timeout: 5000
          // });
          alert('Please select Store');
          return;
        }
        else if (selectedKpiSingle?.length == 0 && kpisSelected.length == 0) {
          alert('Please select Kpi');
          return;
        } 
        else 
        {
          //this.loading = true;
          var selectKpi = kpisSelected?.join(',') ?? ''
          if(reportType.value === 'AllStoresDaily' )
          {
            console.log('selectedKpiSingle.value',selectedKpiSingle.value);
            selectKpi = selectedKpiSingle.value ?? ''
          }
          if(selectKpi !='' || selectKpi != null)
          {
            const exportRequestBody = {
              startDate: selectedStart,
              endDate: selectedEnd,
              compareStartDate: compareStart,
              compareEndDate: compareEnd,
              storeCodes: selectedLocationStore?.join(',') ?? '',
              days: weekDaySelected,
              kpis: selectKpi,//kpisSelected?.join(',') ?? '',
              order: selectedOrder.value,
              // order: this.showSort ? this.sortOrder : '',
              orderKey: selectedDetailedOrder.value,//this.showSort ? this.selectedSort : '',
              reportType: reportType.value,
              lang: 'en'
            };
              console.log('exportRequestBody',exportRequestBody);
              console.log('stores.stores',stores);
             
              await APIExport(exportRequestBody,translation,stores.stores);
          }
        }
      } catch (error) {
        console.log('error',error);
      } 
      // finally {
      //   this.loading = false;
      // }
  };
  //const kpiOptions = kpis;
    return (
      <div>
        <div className="page-wrapper cardhead">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">{translation?.export}</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">{translation?.export_kpi_data}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                <div className="card-body">
                    <div className="row"> 
                      <div className="col-2 d-flex align-items-center"><label>{translation?.filter}:</label> </div>
                      <div className="col-10 export-filter-bar"><FilterBar /></div>
                    </div>
                   
                      <div className="row export-row" style={{marginTop: "-23px"}}>
                
                        <div className="col-2 d-flex align-items-center"><label>{translation?.report_type}:</label> </div>
                        <div className="col-4" style={{paddingLeft: "25px",paddingRight: "25px",zIndex: "4"}}> 
                          <Select
                            value={reportType}
                            onChange={handlereportType}
                            options={reportTypeOptions}
                            className="range-dropdown"
                            placeholder="Custom Range"
                          />
                        </div>
                      </div>
                     
                       {/* Conditional Rendering for KPI Selection */}
                       {/* AllStoresDaily */}
                       {reportType.value !== 'demographics' ? (
                          reportType.value === 'AllStoresDaily' ? (
                            <div className="row export-row">
                              <div className="col-2 d-flex align-items-center">
                                <label>{translation?.select_kpi}:</label>
                              </div>
                              <div className="col-4" style={{ paddingLeft: "25px", paddingRight: "25px", zIndex: "3" }}>
                                <Select
                                  value={selectedKpiSingle}
                                  onChange={handleSelectedKpiSingleChange}
                                  options={kpiOption}
                                  className="range-dropdown"
                                  placeholder={translation?.select_kpi}
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="row export-row">
                              <div className="col-2 d-flex align-items-center">
                                <label>{translation?.select_kpi}:</label>
                              </div>
                              <div className="col-4" style={{ paddingLeft: "34px", paddingRight: "34px", zIndex: "2" }}>
                                <KpisFilter />
                              </div>
                            </div>
                          )
                        ) : (
                          <div className="row">
                            {/* Empty or other content can go here if needed */}
                          </div>
                        )}

                   {reportType.value === 'demographics' || reportType.value === 'AllStoresDaily' ? (
                      <div className="row">
                      </div>
                   ):(
                    <div className="row export-row2">
               
                    <div className="col-2 d-flex align-items-center"><label>{translation?.sort_by}:</label> </div>
                    <div className="col-4" style={{paddingLeft: "25px",paddingRight: "25px",zIndex: "1"}}> 
                      <Select
                        value={selectedDetailedOrder}
                        onChange={handledetailedSortChange}
                        options={detailedSortOptions}
                        className="range-dropdown"
                        placeholder={('Select Report Type')}
                      />
                    </div>
                    <div className="col-4" style={{paddingLeft: "0px",zIndex: "1"}}> 
                      <Select
                        value={selectedOrder}
                        onChange={handleSortOrderChange}
                        options={sortOrderOption}
                        className="range-dropdown"
                      />
                    </div>
                    </div>
                   )}
                    
                    <div className="row">
                      <div className="col-12 d-flex justify-content-end align-items-center"> 
                        <button
                          // disabled={btnLoading}
                          type="button"
                          className="btn btn-submit"
                          onClick={handleExport}
                        >
                          {translation?.export}
                          {/* {!btnLoading ? "Export" : "Wait..."} */}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
export default ExportData;